import type { ReactElement } from 'react';
import { createBrowserRouter } from 'react-router';
import { createAppRoutes, RouteError } from 'components/app-route-switch';
import { setAppRouter } from 'services/router-service';

export const createAppRouter = (element: ReactElement) => {
  const router = createBrowserRouter([{ element, ErrorBoundary: RouteError, children: createAppRoutes() }]);
  setAppRouter(router);
  // Cypress appVisit uses this entry point to navigate without reloading the application.
  // navigate() is async (unlike v6's synchronous history.push), so push must return its promise
  // or a caller that awaits push() races the navigation it just started.
  Object.assign(window, { __history: { push: (url: string) => router.navigate(url) } });
  return router;
};
